import classes from "./industry-five-table.module.scss";
import Flex from "@/components-library/layout/flex";
import Label from "@/components-library/widgets/label";
import classNames from "classnames";
import Grid from "@/components-library/layout/grid";
function IndustryFiveTable() {
  return (
    <Flex
      align="flex-start"
      direction="column"
      justify="flex-start"
      className={classes.table}
    >
      <Grid
        columnGap={"2px"}
        columns="1fr 1fr 1fr 1fr"
        className={classes.header}
      >
        <Label
          tag="p"
          size="md"
          color="default"
          align="start"
          weight="bold"
          className={classNames(classes.firstColumn, classes.item)}
        >
          Quota di investimento
        </Label>
        <Label
          tag="p"
          size="md"
          color="default"
          align="start"
          weight="bold"
          className={classNames(classes.secondColumn, classes.item)}
        >
          {
            "Struttura produttiva tra il 3% e il 6%\nProcesso interessato dell'investimento tra il 6% e il 10%"
          }
        </Label>
        <Label
          tag="p"
          size="md"
          color="default"
          align="start"
          weight="bold"
          className={classNames(classes.thirdColumn, classes.item)}
        >
          {
            "Struttura produttiva tra il 6% e il 10%\nProcesso interessato dell'investimento tra il 10% e il 15%"
          }
        </Label>
        <Label
          tag="p"
          size="md"
          color="default"
          align="start"
          weight="bold"
          className={classNames(classes.fourthColumn, classes.item)}
        >
          {
            "Struttura produttiva > 10%\nProcesso interessato dell'investimento > 15%"
          }
        </Label>
      </Grid>
      <Grid columnGap={"2px"} columns="1fr 1fr 1fr 1fr" className={classes.row}>
        <Label
          tag="p"
          size="md"
          color="secondary"
          align="start"
          weight="bold"
          className={classNames(classes.firstColumn, classes.item)}
        >
          Fino a 2,5 milioni
        </Label>

        <Label
          tag="p"
          size="md"
          color="secondary"
          align="start"
          weight="bold"
          className={classNames(classes.secondColumn, classes.item)}
        >
          35%
        </Label>
        <Label
          tag="p"
          size="md"
          color="secondary"
          align="start"
          weight="bold"
          className={classNames(classes.thirdColumn, classes.item)}
        >
          40%
        </Label>
        <Label
          tag="p"
          size="md"
          color="secondary"
          align="start"
          weight="bold"
          className={classNames(classes.fourthColumn, classes.item)}
        >
          45%
        </Label>
      </Grid>
      <Grid columnGap={"2px"} columns="1fr 1fr 1fr 1fr" className={classes.row}>
        <Label
          tag="p"
          size="md"
          color="secondary"
          align="start"
          weight="bold"
          className={classNames(classes.firstColumn, classes.item)}
        >
          Da 2,5 milioni a 10 milioni
        </Label>

        <Label
          tag="p"
          size="md"
          color="secondary"
          align="start"
          weight="bold"
          className={classNames(classes.secondColumn, classes.item)}
        >
          15%
        </Label>
        <Label
          tag="p"
          size="md"
          color="secondary"
          align="start"
          weight="bold"
          className={classNames(classes.thirdColumn, classes.item)}
        >
          20%
        </Label>
        <Label
          tag="p"
          size="md"
          color="secondary"
          align="start"
          weight="bold"
          className={classNames(classes.fourthColumn, classes.item)}
        >
          25%
        </Label>
      </Grid>
      <Grid columnGap={"2px"} columns="1fr 1fr 1fr 1fr" className={classes.row}>
        <Label
          tag="p"
          size="md"
          color="secondary"
          align="start"
          weight="bold"
          className={classNames(classes.firstColumn, classes.item)}
        >
          Da 10 milioni a 50 milioni
        </Label>

        <Label
          tag="p"
          size="md"
          color="secondary"
          align="start"
          weight="bold"
          className={classNames(classes.secondColumn, classes.item)}
        >
          5%
        </Label>
        <Label
          tag="p"
          size="md"
          color="secondary"
          align="start"
          weight="bold"
          className={classNames(classes.thirdColumn, classes.item)}
        >
          10%
        </Label>
        <Label
          tag="p"
          size="md"
          color="secondary"
          align="start"
          weight="bold"
          className={classNames(classes.fourthColumn, classes.item)}
        >
          15%
        </Label>
      </Grid>
    </Flex>
  );
}

export default IndustryFiveTable;
